import React from 'react';

/**
 * Search button.
 *
 * @param {string} label, aria-label.
 * @param {string} type, type of button.
 * @return {JSX.Element}
 * @constructor
 */
const SearchButton = ({ label = 'Search', type = 'submit' }) => {
  const { svg_sprite } = wp_variables;

  return (
      <button type={type} className="denhaag-search-form__button denhaag-button denhaag-button--search" aria-label={label}>
        <svg className="denhaag-icon" aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <use href={`${svg_sprite}#nlds-icon-search`} />
        </svg>
      </button>
  );
};

export default SearchButton;
